import { render, staticRenderFns } from "./popup-bind-she-bei.vue?vue&type=template&id=936c7782&scoped=true"
import script from "./popup-bind-she-bei.vue?vue&type=script&lang=js"
export * from "./popup-bind-she-bei.vue?vue&type=script&lang=js"
import style0 from "./popup-bind-she-bei.vue?vue&type=style&index=0&id=936c7782&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936c7782",
  null
  
)

export default component.exports